import moment from 'moment';
import * as Yup from 'yup';

export interface ISpecForm {
  expertiseCode: { label: string; value: string } | null;
  from?: Date;
}

export const initialValues: ISpecForm = {
  expertiseCode: null,
  from: undefined,
};

export const validationSchema = Yup.object().shape({
  expertiseCode: Yup.mixed().required('validation.required'),
  from: Yup.date()
    .max(moment().endOf('day'), 'Dátum musí byť maximálne dnešný')
    .required('validation.required'),
});
